/*
 *  Copyright (c) 2021. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import { Helmet } from "react-helmet-async";

import { gaSet } from "../../../../../services/cookieService";

const SchufaWbsPageMeta = () => {
  const title = "Vom Datenweitergabe-Skandal betroffen? Jetzt Anspruch prüfen! | WBS & Legalbird";
  gaSet({ title: title });

  return (
      <Helmet>
        <title>{title}</title>
        <meta
          name="description"
          content="Deine Daten wurden ohne Zustimmung an die SCHUFA weitergegeben? Lasse deinen Anspruch auf Schadensersatz kostenlos online prüfen - ganz ohne Anwaltsbesuch!"
        />
        <meta name="keywords" content="WBS, Legalbird, SCHUFA, Datenweitergabe, Anspruch auf Schadensersatz prüfen, Handyvertrag" />
        <meta name="robots" content="index,follow" />
        <meta property="og:title" content={title} />
        <meta property="og:locale" content="de_DE" />
        <meta property="og:type" content="website" />
        <meta
          property="og:description"
          content="Deine Daten wurden ohne Zustimmung an die SCHUFA weitergegeben? Lasse deinen Anspruch auf Schadensersatz kostenlos online prüfen - ganz ohne Anwaltsbesuch!"
        />
      </Helmet>
  );
};

export default SchufaWbsPageMeta;
